import { createAction, props } from "@ngrx/store";
export const poiSearch = createAction('[tab-poi] PoiSearch', props());
